import apiService from "services/api";
import { useQuery } from "react-query";
import { ImageModal, ProtectedImg } from "components";
import { Link } from "react-router-dom";
import { useState } from "react";
import { getFileExtension } from "utils/getFileExtension";
import { useReducer } from "react";
import { modalActions, modalInitialState, modalReducer } from "./reducers";
import { StaffApplicationModal } from "./StaffApplicationModal";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { buildDateTime } from "utils/dateHelper";
import moment from "moment";
import { CalendarCustomToolbar } from "components";
import { absTimeDifference } from "utils/timeDifference";

const transformData = (events) =>
	events.map((event) => {
		const eventDate = buildDateTime(event.date);
		return {
			...event,
			start: eventDate,
			end: eventDate,
			title: `${event.isOt ? "OT" : event.type} (${
				event.isOt
					? (absTimeDifference(event.startTime, event.endTime) / 60).toFixed(2) + "h"
					: event.period === "HD"
					? event.amPm
					: event.period
			}) ${event.deleted ? "Deleted" : ""} ${event.approved ? "[Approved]" : "[Pending]"}`,
		};
	});

const localizer = momentLocalizer(moment);

const MyStaffApplicationTemplate = ({ type = "leave" }) => {
	const { data: events, refetch } = useQuery([type, "self"], () =>
		Promise.resolve(type === "leave" ? apiService.leave.self() : apiService.ot.self()).then(transformData)
	);

	const [displayApplicationModalState, displayApplicationModalDispatch] = useReducer(modalReducer, modalInitialState);

	const [imgExpanded, expandImage] = useState(false);

	const displayLeaveModal = (event) => {
		displayApplicationModalDispatch({ type: modalActions.MODAL_OPEN });
		displayApplicationModalDispatch({ type: modalActions.SET_DATA, payload: event });
	};

	return (
		<div className="content">
			<div className="d-flex">
				<Link to={`/${type.toLowerCase()}/new`}>
					<button type="button" className="btn btn-info">
						Add new {type}
					</button>
				</Link>
			</div>

			<StaffApplicationModal
				state={displayApplicationModalState}
				dispatch={displayApplicationModalDispatch}
				refetch={refetch}
				expandImage={expandImage}
				type={type}
			/>

			{getFileExtension(displayApplicationModalState?.data?.proof) !== "pdf" && (
				<ImageModal open={imgExpanded} hideModal={() => expandImage(false)}>
					<ProtectedImg src={displayApplicationModalState?.data?.proof} alt="" className="img-fluid" />
				</ImageModal>
			)}

			<div style={{ height: 500 }}>
				<Calendar
					selectable
					localizer={localizer}
					longPressThreshold={200}
					events={events || []}
					defaultView="month"
					defaultDate={new Date()}
					onSelectEvent={displayLeaveModal}
					dayLayoutAlgorithm="no-overlap"
					components={{ toolbar: CalendarCustomToolbar }}
					popup
					messages={{
						showMore: (total) => (
							<div
								style={{ cursor: "pointer" }}
								className="text-center"
								onMouseOver={(e) => {
									e.preventDefault();
								}}
							>
								{`+${total}`}
							</div>
						),
					}}
				/>
			</div>
		</div>
	);
};

export default MyStaffApplicationTemplate;
